import type { Upload } from '@/types';

export function getUploadIdentifier(upload: Upload): string {
  return upload.uuid ?? String(upload.id);
}
